<template>
  <div class="tab-selector">
    <div class="label">{{label}}</div>
    <div class="row">
      <div
        class="col"
        v-for="item in list"
        v-text="getText(item)"
        @click="selectItem(getValue(item))"
        v-bind:class="{isSelectedTab: getValue(item) === value}"
      >
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    name: 'tab-selector',
    props: {
      value: 0,
      list: {
        type: Array,
        required: true,
        default: []
      },
      textKey: {
        type: String,
        required: true,
        default: "unit"
      },
      valueKey: {
        type: String,
        required: true,
        default: "preference_id"
      },
      label: {
        type: String,
        default: ''
      }
    },
    methods: {
      getText(item) {
        return item[this.textKey];
      },
      getValue(item) {
        return item[this.valueKey];
      },
      selectItem(value) {
        let self = this.$emit('input', value)
      }
    }
  }
</script>

<style lang="less">


  @import '../../../styles/theme.less';

  .tab-selector {
    margin-bottom: 24px;
    .label {
      margin-bottom: 8px;
    }


    .row {
      .col {
        display: block;
        padding: 9px;
        font-weight: 500;
        color: @primaryColor !important;
        border-left: 1px solid @primaryColor;
        -webkit-transition: all 100ms linear;
        -moz-transition: all 100ms linear;
        -ms-transition: all 100ms linear;
        -o-transition: all 100ms linear;
        transition: all 100ms linear;
        cursor: pointer;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        &.isSelectedTab {
          color: #FFFFFF;
        }
        &:first-child {
          border-left: 0;
        }
      }
    }

    .row {
      border-radius: 4px;
      border: solid 1px @primaryColor;
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      -ms-flex-wrap: wrap;
      flex-wrap: wrap;
      .col.isSelectedTab {
        background: @primaryColor !important;
        color: white !important;
      }
      .col {
        text-align: center;
        -ms-flex-preferred-size: 0;
        flex-basis: 0;
        -webkit-box-flex: 1;
        -ms-flex-positive: 1;
        flex-grow: 1;
        max-width: 100%;
        padding: 8px;
        @media (max-width: 800px) {
          font-size: 12px !important;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// TabSelector.vue?360ac914